import { getSourceId } from '@pn/core/domain/workspace';
import type { MapboxIMap } from '..';
import { getMapboxAnnotationsLayers } from './addAnnotationLayer';

export const addQueryAreaOutline: MapboxIMap['addQueryAreaOutline'] = function (
  this: MapboxIMap,
  itemId,
  geometry,
  style
) {
  const layerId = `query-area-${itemId}`;
  const sourceId = getSourceId(layerId);

  const data: GeoJSON.FeatureCollection = {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: {
          lineColor: style.lineColor,
          lineWidth: 2,
          fillColor: style.fillColor,
          fillOpacity: 0.15,
        },
        geometry,
      },
    ],
  };

  const existingSource = this._native.getSource(sourceId) as
    | mapboxgl.GeoJSONSource
    | undefined;

  if (existingSource) {
    existingSource.setData(data);
    return;
  }

  this._native.addSource(sourceId, { type: 'geojson', data });

  const strokeLayerId = `${layerId}-polygons-stroke`;

  getMapboxAnnotationsLayers(layerId).forEach((layer) => {
    this._native.addLayer({
      ...layer,
      source: sourceId,
      /* Only the outline (not the annotation defaults) is dashed. */
      ...(layer.id === strokeLayerId
        ? { paint: { ...layer.paint, 'line-dasharray': [2, 2] } }
        : {}),
    } as mapboxgl.AnyLayer);
  });
};
